import { of } from 'rxjs';
import { AuthenticationService } from './Authentication.service';

const getMock: () => Partial<AuthenticationService> = () => {
    const mockAuthenticationService: Partial<AuthenticationService> = {
        isAuthenticated: () => of(true),
        goToApplication: async () => {}
    };

    return mockAuthenticationService;
};

export const authenticationServiceMock = {
    getMock,
    provider: (Service: typeof AuthenticationService) => ({
        provide: Service,
        useValue: getMock()
    })
};
